import Vue from 'vue';
import { firestorePlugin } from 'vuefire';

Vue.use(firestorePlugin);
